'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContentWrapperStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var content = function content() {
  return '\n  & > * {\n    &,\n    &:hover,\n    &:focus {\n      color: inherit;\n      text-decoration: none;\n      cursor: inherit;\n    }\n  }\n';
};

var TabContentWrapperStyled = exports.TabContentWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TabContentWrapperStyled'
})(['flex-grow:1;display:flex;align-items:center;justify-content:center;', ';'], content);

TabContentWrapperStyled.displayName = 'TabContentWrapperStyled';